export enum LocalesNamespace {
  SHARED = 'shared',
  MODULES_CART = 'modules/cart',
  MODULES_USER = 'modules/user',
  MODULES_PRODUCT = 'modules/product',
  MODULES_ORDER = 'modules/order',
  MODULES_CHECKOUT = 'modules/checkout',
  MODULES_SEARCH = 'modules/search',
}
